import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import ErrorPage from "components/error/error.component";
import Authentication, { authRoutes } from "./auth";
import ProtectedRoutes, { protectedRoutes } from "./protected-routes";
import Root from "./root";
import InitialState from "components/toolkit/initial-state.component";
import Preloader from "components/preloader";
import { policyLoader } from "loaders/policy";
import Analytics from "./analytics";
import Propagate from "./auth/propagate";

const Home = lazy(() => import("./home"));
const PolicyPage = lazy(() => import("./policy"));
const FAQPage = lazy(() => import("./faq"));
const VendorContest = lazy(() => import("components/VendorContest"));
const ThankYou = lazy(() => import("./vendor-contest/thank-you"));
const VendorAcqusitionPage = lazy(() => import("./vendor-acquisition"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Analytics />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: (
          <Suspense fallback={<Preloader />}>
            <Root />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            element: <Home />,
          },
          {
            path: "/vendor-contest",
            element: <VendorContest />,
          },
          {
            path: "/vendor-contest/thank-you",
            element: <ThankYou />,
          },
          {
            path: "/faq",
            element: <FAQPage />,
          },
          {
            path: "/policy/:slug",
            element: (
              <Suspense fallback={<Preloader />}>
                <PolicyPage />
              </Suspense>
            ),
            loader: policyLoader,
            errorElement: <ErrorPage />,
          },
          {
            path: "/vendor-acquisition",
            element: <VendorAcqusitionPage />,
          },
        ],
      },
      {
        element: (
          <Suspense fallback={<Preloader />}>
            <Authentication />
          </Suspense>
        ),
        loader: () => <Preloader />,
        errorElement: <ErrorPage />,
        children: authRoutes,
      },
      {
        path: "/auth/login-vendor",
        element: <Propagate />,
      },
      {
        element: (
          <Suspense fallback={<Preloader />}>
            <InitialState />
            <ProtectedRoutes />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
        children: protectedRoutes,
      },
    ],
  },
]);

export default router;
